export * from './image-resource.model';
export * from './image-resource-popup.service';
export * from './image-resource.service';
export * from './image-resource-dialog.component';
export * from './image-resource-delete-dialog.component';
export * from './image-resource-detail.component';
export * from './image-resource.component';
export * from './image-resource.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/image-resource/index.ts